import React, { useEffect } from 'react';
import { useIntl } from '@leagueplatform/locales';
import { MedicarePrescriptionPaymentPlanMasonrySection } from 'components/premium-payment/medicare-prescription-payment-plan-masonry-section.component';
import { PremiumPaymentLayout } from 'components/premium-payment/premium-payment-layout.component';
import { sendMedicarePrescriptionPaymentPlanScreenLoadedEvent } from 'utils/analytics-events';
import { useGoBack } from 'hooks/use-go-back.hook';

const MedicarePrescriptionPaymentPlanPage = () => {
  const { formatMessage } = useIntl();
  const { handleGoBack } = useGoBack();
  const title = formatMessage({ id: 'STR_MEDICARE_PRESCRIPTION_PAYMENT_PLAN' });

  useEffect(() => {
    sendMedicarePrescriptionPaymentPlanScreenLoadedEvent();
  }, []);

  return (
    <PremiumPaymentLayout
      title={title}
      goBack={handleGoBack}
      additionalCss={{
        a: {
          textAlign: 'center',
          justifyContent: 'center',
          maxWidth: '227px',
          whiteSpace: 'nowrap',
        },
      }}
    >
      <MedicarePrescriptionPaymentPlanMasonrySection />
    </PremiumPaymentLayout>
  );
};

export default MedicarePrescriptionPaymentPlanPage;
